import React from 'react'
import Layout from '../../../brands/components/Layout'
import { Formik } from 'formik'
import { InputField } from '../../../../components'
import './index.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { ChangePasswordSchema, ChangePasswordAdminSchema } from '../schema'
import { ChangePsswrd } from '../type'
import { changePassword } from '../api'
import { changePasswordByAdmin } from '../../../../features/userslisting/api/index'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'

const ChangePassword: React.FC = () => {
    const location = useLocation()
    const pathname = location.pathname
    const userId = pathname.substring(pathname.lastIndexOf('/') + 1)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Change Password</h4>
                    </div>

                    <div className=" mt-3">
                        <Formik
                            initialValues={{
                                newPassword: '',
                                password: '',
                                confirmNewPassword: '',
                            }}
                            validationSchema={
                                location.pathname === '/profile/changepassword'
                                    ? ChangePasswordSchema
                                    : ChangePasswordAdminSchema
                            }
                            onSubmit={async (values: ChangePsswrd) => {
                                let response
                                dispatch(SHOW_LOADER())
                                try {
                                    if (
                                        location.pathname ===
                                        '/profile/changepassword'
                                    ) {
                                        response = await changePassword(values)
                                    } else {
                                        const requestBody = {
                                            userId: userId,
                                            newPassword: values.newPassword,
                                            confirmPassword:
                                                values.confirmNewPassword,
                                        }
                                        response =
                                            await changePasswordByAdmin(
                                                requestBody
                                            )
                                    }

                                    if (response.status === 200) {
                                        dispatch(HIDE_LOADER())
                                        dispatch(
                                            SHOW_NOTIFICATION({
                                                type: 'success',
                                                message:
                                                    'Your Password has been changed',
                                            })
                                        )
                                        location.pathname ===
                                        '/profile/changepassword'
                                            ? navigate('/profile')
                                            : navigate('/users')
                                    }
                                } catch (err) {
                                    console.error('Error fetching..', err)
                                    dispatch(HIDE_LOADER())
                                } finally {
                                    dispatch(HIDE_LOADER())
                                }
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    {location.pathname ===
                                        '/profile/changepassword' && (
                                        <div className="row  mrg-top">
                                            <div className="col-sm-6">
                                                <InputField
                                                    type="password"
                                                    lable={'Current Password'}
                                                    name="password"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.password}
                                                    touched={touched.password}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="row  mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="password"
                                                lable={'New Password'}
                                                name="newPassword"
                                                value={values.newPassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.newPassword}
                                                touched={touched.newPassword}
                                            />
                                        </div>
                                    </div>

                                    <div className="row  mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="password"
                                                lable={'Confirm Password'}
                                                name="confirmNewPassword"
                                                value={
                                                    values.confirmNewPassword
                                                }
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={
                                                    errors.confirmNewPassword
                                                }
                                                touched={
                                                    touched.confirmNewPassword
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="d-flex justify-content-between">
                                            <div></div>
                                            <div>
                                                <div className="button-block button-block-inline">
                                                    <Button
                                                        className="button button-primary me-5"
                                                        type="submit"
                                                        // onClick={() =>
                                                        //     location.pathname ===
                                                        //     '/profile/changepassword'
                                                        //         ? navigate(
                                                        //               '/profile'
                                                        //           )
                                                        //         : navigate(
                                                        //               '/users'
                                                        //           )
                                                        // }
                                                    >
                                                        SAVE
                                                    </Button>
                                                    <Button
                                                        className="button button-outline"
                                                        onClick={() =>
                                                            location.pathname ===
                                                            '/profile/changepassword'
                                                                ? navigate(
                                                                      '/profile'
                                                                  )
                                                                : navigate(
                                                                      '/users'
                                                                  )
                                                        }
                                                    >
                                                        CANCEL
                                                    </Button>
                                                </div>
                                                {/* <div className="button-block ">
                                                    <a
                                                        className="button button-primary me-5"
                                                        onClick={() =>
                                                            location.pathname ===
                                                            '/profile/changepassword'
                                                                ? navigate(
                                                                      '/profile'
                                                                  )
                                                                : navigate(
                                                                      '/users'
                                                                  )
                                                        }
                                                    >
                                                        SAVE
                                                    </a>
                                                    <a
                                                        className="button button-outline"
                                                        onClick={() =>
                                                            location.pathname ===
                                                            '/profile/changepassword'
                                                                ? navigate(
                                                                      '/profile'
                                                                  )
                                                                : navigate(
                                                                      '/users'
                                                                  )
                                                        }
                                                    >
                                                        CANCEL
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default ChangePassword
